import type { FontAwesomeWeight, IconName } from './types'

const CART_SHOPPING = 'cart-shopping'
const MOBILE_SCREEN_BUTTON = 'mobile-screen-button'
const CHART_MIXED = 'chart-column'

/** The single Font Awesome seam; feature callers keep using typed, vendor-neutral tokens. */
export const FONT_AWESOME_NAMES = {
  'medical-kit': 'kit-medical',
  'briefcase-medical': 'briefcase-medical',
  'alert-triangle': 'triangle-exclamation',
  'circle-alert': 'circle-exclamation',
  'circle-check': 'circle-check',
  'circle-x': 'circle-xmark',
  info: 'circle-info',
  'eye-off': 'eye-slash',
  'circle-question': 'circle-question',
  'shield-check': 'shield',
  bolt: 'bolt',
  clock: 'clock',
  download: 'download',
  'external-link': 'arrow-up-right-from-square',
  'arrow-right': 'arrow-right',
  'arrow-up-long': 'arrow-up-long',
  'arrow-down-long': 'arrow-down-long',
  'arrow-up-right': 'arrow-up',
  'arrow-down-right': 'arrow-down',
  'rotate-left': 'rotate-left',
  check: 'check',
  'chevron-up': 'chevron-up',
  'chevron-down': 'chevron-down',
  'chevron-right': 'chevron-right',
  'chevron-left': 'chevron-left',
  ellipsis: 'ellipsis',
  'diagram-project': 'diagram-project',
  'objects-align-right': 'align-right',
  sliders: 'sliders',
  bookmark: 'bookmark',
  expand: 'expand',
  compress: 'compress',
  'ellipsis-vertical': 'ellipsis-vertical',
  gear: 'gear',
  plus: 'plus',
  filter: 'filter',
  search: 'magnifying-glass',
  'square-pen': 'square-pen',
  'square-check': 'square-check',
  pencil: 'pencil',
  'pen-to-square': 'pen-to-square',
  pen: 'pen',
  gem: 'gem',
  'alert-sensor': 'sensor-triangle-exclamation',
  sparkle: 'sparkles',
  'panel-left': 'table-columns',
  'sidebar-right': 'sidebar-flip',
  messages: 'comments',
  menu: 'bars',
  megaphone: 'megaphone',
  'message-dot': 'message-dot',
  'thumbs-up': 'thumbs-up',
  'paper-airplane': 'paper-plane',
  sparkles: 'wand-magic-sparkles',
  x: 'xmark',
  'magnifying-glass-chart': 'magnifying-glass-chart',
  'circle-nodes': 'circle-nodes',
  'folder-image': 'images',
  'chart-line-up': 'chart-line',
  'rocket-launch': 'rocket',
  user: 'user',
  globe: 'globe',
  'clipboard-list': 'clipboard-list',
  'clipboard-check': 'clipboard-check',
  'block-quote': 'block-quote',
  'chart-user': 'chart-user',
  folder: 'folder',
  'cart-shopping': CART_SHOPPING,
  'plane-departure': 'plane-departure',
  'mobile-screen-button': MOBILE_SCREEN_BUTTON,
  orpheus: 'sparkles',
  'layer-group': 'layer-group',
  box: 'box',
  'boxes-stacked': 'boxes-stacked',
  'cart-flatbed-boxes': 'cart-flatbed',
  chart: 'chart-column',
  database: 'database',
  ad: 'rectangle-ad',
  cart: CART_SHOPPING,
  users: 'users',
  mobile: MOBILE_SCREEN_BUTTON,
  code: 'code',
  image: 'image',
  video: 'video',
  type: 'font',
  plane: 'plane',
  trash: 'trash',
  'arrow-left': 'arrow-left',
  lock: 'lock',
  'lock-open': 'lock-open',
  coins: 'coins',
  play: 'play',
  'calendar-check': 'calendar-check',
  'calendar-days': 'calendar-days',
  'caret-down': 'sort-down',
  sun: 'sun',
  moon: 'moon',
  repeat: 'repeat',
  'sack-dollar': 'sack-dollar',
  'traffic-cone': 'traffic-light',
  browser: 'window-maximize',
  eye: 'eye',
  heart: 'heart',
  'door-open': 'door-open',
  'right-to-bracket': 'right-to-bracket',
  'link-slash': 'link-slash',
  'arrow-pointer': 'arrow-pointer',
  hand: 'hand',
  'chart-mixed': CHART_MIXED,
  'money-bill': 'money-bill',
  images: 'images',
  'video-monitor': 'video-monitor',
  text: 'text',
  'boxes-packing': 'boxes-packing',
  'folder-arrow-up': 'folder-arrow-up',
  'folder-tree': 'folder-tree',
  'list-tree': 'list-tree',
  'hexagon-nodes': 'hexagon-nodes',
  'gallery-thumbnails': 'gallery-thumbnails',
  'arrow-trend-up': 'arrow-trend-up',
  'arrow-up-wide-short': 'arrow-up-wide-short',
  'arrow-trend-down': 'arrow-trend-down',
  'image-stack': 'image-stack',
  'photo-film': 'photo-film',
  'list-dropdown': 'list-dropdown',
  'object-group': 'object-group',
  'list-magnifying-glass': 'list-magnifying-glass',
  'users-viewfinder': 'users-viewfinder',
  'line-columns': 'line-columns',
  'hand-holding-dollar': 'hand-holding-dollar',
  'person-half-dress': 'person-half-dress',
  'location-dot': 'location-dot',
  'chart-line': 'chart-line',
  'chart-area': 'chart-area',
  'window-restore': 'window-restore',
  'comment-plus': 'comment-plus',
  bug: 'bug',
  display: 'display',
  'id-badge': 'id-badge',
  'network-wired': 'network-wired',
  bell: 'bell',
  'address-book': 'address-book',
  'file-invoice': 'file-invoice',
  'file-pdf': 'file-pdf',
  copy: 'copy',
  'chart-bar': 'chart-bar',
  'chart-pie': 'chart-pie-simple',
  // fa-chart-donut is not resolved by the licensed kit; fa-ring is the closest donut glyph.
  'chart-donut': 'ring',
  'chart-scatter': 'chart-scatter',
  'chart-scatter-bubble': 'chart-scatter-bubble',
  'table-cells-large': 'table-cells-large',
  'grid-2': 'grid-2',
  'grip-vertical': 'grip-vertical',
  'filter-circle-dollar': 'filter-circle-dollar',
  'chart-waterfall': 'chart-waterfall',
  radar: 'radar',
  'gauge-high': 'gauge-high',
  'diagram-predecessor': 'diagram-predecessor',
  lollipop: 'lollipop',
  building: 'building',
  envelope: 'envelope',
  'arrow-up': 'arrow-up',
  'arrow-down': 'arrow-down',
  'arrow-rotate-right': 'arrow-rotate-right',
  'magnifying-glass-plus': 'magnifying-glass-plus',
  'magnifying-glass-minus': 'magnifying-glass-minus',
  'image-slash': 'image-slash',
  minus: 'minus',
  key: 'key',
  paperclip: 'paperclip',
  'file-csv': 'file-csv',
  'file-excel': 'file-excel',
  'wave-square': 'wave-square',
  'pen-swirl': 'pen-swirl',
  'circle-plus': 'circle-plus',
  plug: 'plug',
} as const satisfies Record<IconName, string>

export function fontAwesomeClasses(
  name: IconName,
  presentation: 'default' | 'legacy-rail' = 'default',
  weight?: FontAwesomeWeight,
): string[] {
  const family = weight ?? (presentation === 'legacy-rail' ? 'light' : 'solid')
  return [`fa-${family}`, `fa-${FONT_AWESOME_NAMES[name] || name}`]
}
